import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';

import getMeetSessionData from './GetMeetSessionData';
import getMeetSessionsSetIsQualifyingForAllSessionsInMeetData from './GetMeetSessionsSetIsQualifyingForAllSessionsInMeetData';
import postMeetSessionData from './PostMeetSessionData'
import putMeetSessionData from './PutMeetSessionData';
import deleteMeetSessionData from './DeleteMeetSessionData';

import Constants from '../../utils/Constants';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  meetId: Constants.DEFAULT_ID,
  options: []
};

const OtsMeetSessionsData = {
  INITIAL_STATE, getMeetSessionData, getMeetSessionsSetIsQualifyingForAllSessionsInMeetData,
  postMeetSessionData, putMeetSessionData, deleteMeetSessionData
}

export default OtsMeetSessionsData;